import React from 'react';
import { Skeleton } from '@mui/material';

const SKELETON_ROWS = 4;
const ROW_HEIGHT = 53;
const SKELETON_BORDER_RADIUS = 6;
const SKELETON_GRADIENT = 'linear-gradient(90deg, #fbfbfb 0%, #ededed 51.923%, #efefef 100%)';

const RequestsSkeleton = () => (
    <div className="cash-wallet-requests-skeleton">
        <div className="cash-wallet-request-rows-skeleton">
            {Array.from({ length: SKELETON_ROWS }).map((_, index) => (
                <Skeleton
                    key={index}
                    variant="rounded"
                    width="100%"
                    height={ROW_HEIGHT}
                    sx={{ borderRadius: `${SKELETON_BORDER_RADIUS}px`, background: SKELETON_GRADIENT }}
                />
            ))}
        </div>
    </div>
);

export default RequestsSkeleton;
